import React from 'react'
import { Button } from 'antd'

type HomeSectionStateProps = {
  type: 'empty' | 'error'
  title: string
  description: string
  actionLabel?: string
  onAction?: () => void
}

/**
 * 首页区域统一空态/错误态。
 */
const HomeSectionState: React.FC<HomeSectionStateProps> = ({
  type,
  title,
  description,
  actionLabel,
  onAction,
}) => {
  const isError = type === 'error'
  return (
    <div className={`rounded-lg border px-4 py-10 text-center ${isError ? 'border-red-100 bg-red-50/70' : 'border-gray-100 bg-gray-50'}`}>
      <div className={`text-base font-semibold ${isError ? 'text-red-600' : 'text-gray-700'}`}>{title}</div>
      <div className={`mt-2 text-sm ${isError ? 'text-red-500' : 'text-gray-500'}`}>{description}</div>
      {actionLabel && onAction ? (
        <Button className="mt-4" type={isError ? 'default' : 'primary'} onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </div>
  )
}

export default HomeSectionState
